import { createAction, props } from '@ngrx/store';
import{ Booking } from '../../../../@core/data/models/booking.model';
import { FileItinerary } from '../../../../@core/data/models/file-itinerary.model';
import { BookingDetail } from '@app/@core/data/models/booking-detail.model';
import { BookingReport, BookingReportType } from '@app/@core/data/models/booking-report.model';
import { Document } from '@app/@core/data/models/document.model';

export enum BookingActions {
  BOOKING_LOAD_BOOKING = '[Bookings] Load Booking',
  BOOKING_LOAD_BOOKING_SUCCESS = '[Bookings] Load Booking Success',
  BOOKING_LOAD_BOOKING_FAILURE = '[Bookings] Load Booking Failure',

  BOOKING_LOAD_BOOKING_DETAILS = '[Bookings] Load Booking Details',
  BOOKING_LOAD_BOOKING_DETAILS_SUCCESS = '[Bookings] Load Booking Details Success',
  BOOKING_LOAD_BOOKING_DETAILS_FAILURE = '[Bookings] Load Booking Details Failure',

  BOOKING_LOAD_BOOKING_REPORT = '[Bookings] Load Booking Report',
  BOOKING_LOAD_BOOKING_REPORT_SUCCESS = '[Bookings] Load Booking Report Success',
  BOOKING_LOAD_BOOKING_REPORT_FAILURE = '[Bookings] Load Booking Report Failure',

  BOOKING_LOAD_BOOKING_DOCUMENT_LIST = '[Bookings] Load Booking Document List',
  BOOKING_LOAD_BOOKING_DOCUMENT_LIST_SUCCESS = '[Bookings] Load Booking Document List Success',
  BOOKING_LOAD_BOOKING_DOCUMENT_LIST_FAILURE = '[Bookings] Load Booking Document List Failure',

  BOOKINGS_LOAD_FILE_ITINERARY = '[Bookings] Load All File Itnerary',
  BOOKINGS_LOAD_FILE_ITINERARY_SUCCESS = '[Bookings] Load All File Itnerary Success',

  BOOKINGS_DOWNLOAD_DOCUMENT = '[Bookings] Download document',
  BOOKINGS_DOWNLOAD_DOCUMENT_SUCCESS = '[Bookings] Download document success',
  BOOKINGS_DOWNLOAD_DOCUMENT_FAILURE = '[Bookings] Download document failure',
  BOOKINGS_DOWNLOAD_DOCUMENT_CLEAN = '[Bookings] Download document clean',
}

export const loadBooking = createAction(
  BookingActions.BOOKING_LOAD_BOOKING,
  props<{ company: string; file: string }>(),
);

export const loadBookingSuccess = createAction(
  BookingActions.BOOKING_LOAD_BOOKING_SUCCESS,
  props<{ payload: { booking: Booking } }>(),
);

export const loadBookingFailure = createAction(
  BookingActions.BOOKING_LOAD_BOOKING_FAILURE,
  props<{ payload: { error: string } }>(),
);

export const loadBookingDetails = createAction(
  BookingActions.BOOKING_LOAD_BOOKING_DETAILS,
  props<{ bookingId: string; companyId: string }>(),
);

export const loadBookingDetailsSuccess = createAction(
  BookingActions.BOOKING_LOAD_BOOKING_DETAILS_SUCCESS,
  props<{ payload: { details: BookingDetail[] } }>(),
);

export const loadBookingDetailsFailure = createAction(
  BookingActions.BOOKING_LOAD_BOOKING_DETAILS_FAILURE,
  props<{ payload: { error: string } }>(),
);

export const loadBookingReport = createAction(
  BookingActions.BOOKING_LOAD_BOOKING_REPORT,
  props<{ bookingId: string; companyId: string}>(),
);

export const loadBookingReportSuccess = createAction(
  BookingActions.BOOKING_LOAD_BOOKING_REPORT_SUCCESS,
  props<{ payload: { report: BookingReport[] } }>(),
);

export const loadBookingReportFailure = createAction(
  BookingActions.BOOKING_LOAD_BOOKING_REPORT_FAILURE,
  props<{ payload: { error: any } }>(),
);

export const loadBookingDocuments = createAction(
  BookingActions.BOOKING_LOAD_BOOKING_DOCUMENT_LIST,
  props<{ fileId: string; companyId: string}>(),
);

export const loadBookingDocumentsSuccess = createAction(
  BookingActions.BOOKING_LOAD_BOOKING_DOCUMENT_LIST_SUCCESS,
  props<{ payload: { documents: Document[] } }>(),
);

export const loadBookingDocumentsFailure = createAction(
  BookingActions.BOOKING_LOAD_BOOKING_DOCUMENT_LIST_FAILURE,
  props<{ payload: { error: any } }>(),
);

export const loadFileItineraries = createAction(
  BookingActions.BOOKINGS_LOAD_FILE_ITINERARY,
  props<{ bookingId: string; companyId: string }>(),
);

export const loadFileItinerariesSuccess = createAction(
  BookingActions.BOOKINGS_LOAD_FILE_ITINERARY_SUCCESS,
  props<{ payload: { fileItineraries: FileItinerary[] } }>(),
);

export const DownloadDocument = createAction(
  BookingActions.BOOKINGS_DOWNLOAD_DOCUMENT,
  props<{ id: string; companyId: string }>(),
);

export const DownloadDocumentSuccess = createAction(
  BookingActions.BOOKINGS_DOWNLOAD_DOCUMENT_SUCCESS,
  props<{ payload: { documentLink: any } }>(),
);

export const cleanDocumentLink = createAction(
  BookingActions.BOOKINGS_DOWNLOAD_DOCUMENT_CLEAN,
);

